import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

const isIosDevice = Platform.OS === 'ios';
export default StyleSheet.create({
  actionBottomContainer: {
    alignItems: 'flex-start',
  },
  actionBottom: {
    marginTop: 6.6,
    height: 31.1,
    paddingHorizontal: 16.7,
  },
  actionBottomText: {
    color: Colors.dark_grey,
    fontFamily: Fonts.type.bold.fontFamily,
    ...Fonts.type.bold,
    fontSize: 17,
  },
  errorItemDescription: {
    marginLeft: 52,
    paddingBottom: 10,
  },
  errorItemDescriptionText: {
    lineHeight: 24,
    paddingBottom: 10,
    fontSize: 16.7,
  },
  iconContainer: {
    width: 32, // same as headding icon size to be aligned with it
    alignItems: 'center',
  },
  errorItemTitle: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: 10,
  },
  errorItemTitleText: isBold => ({
    alignSelf: 'center',
    color: Colors.dark_grey,
    fontSize: 18,
    marginLeft: 20,
    paddingTop: isIosDevice ? (isBold ? 5 : 1) : null,
    fontFamily: isBold ? Fonts.type.bold.fontFamily : Fonts.type.VFFont,
    fontWeight: isBold ? Fonts.type.bold.fontWeight : 'normal',
  }),
  itemContainer: isLastElement => ({
    paddingTop: 13,
    paddingBottom: isLastElement ? 0 : 13,
  }),
});
